import { Moment } from 'moment';

import { refreshMessages } from '../../contacts/actions/refresh-messages';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const setHireStartDateTime = (
  jobApplicantId: number,
  orgId: number,
  hireStartDateTime: Moment | null,
) =>
  createGenericDispatcher({
    name: 'SET_HIRE_DATE',
    loadFunction: () =>
      Api.post(`/application/${jobApplicantId}/hireStartDateTime`, {
        body: JSON.stringify({
          hireStartDateTime,
        }),
      }),
    args: { jobApplicantId, hireStartDateTime, orgId },
    onSuccess: (
      dispatch: Function,
      getState: Function,
      data: {
        reminders: Array<Record<string, any>>;
      },
    ) => {
      /*
      If this call resulted in scheduled reminders, refresh messages to show them.
     */
      if (data.reminders.length > 0) {
        const applicant = getState().applications.applicationsById[jobApplicantId];
        if (applicant) {
          dispatch(refreshMessages(applicant.contactId));
        }
      }
    },
  });
